// react
import { useContext, useState } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// types
import { Pagination, Tag } from '../../../../../@types';

// router
import { useSearchParams } from 'react-router-dom';

// context
import { ContextProject } from '../../Project.context';

// hooks
import { useFetch } from '../../../../../hooks/useFetch';

// mui
import { Container, Grid, Paper, Typography } from '@mui/material';

// forms
import { FormAddTag } from '../../../../forms/FormAddTag/FormAddTag';

// tables
import { TableBasicTags } from '../../../../tables/basic/TableBasicTags/TableBasicTags';

// utils
import { defaultPagination } from '../../../../../utils/defaults';

export const Tags = () => {
	// session
	const accessToken = sessionStorage.getItem('accessToken');
	const idToken = sessionStorage.getItem('idToken');

	// hooks
	const [searchParams] = useSearchParams();
	const { t } = useTranslation();

	// params
	const paramPage = Number(searchParams.get('page') || 1);

	// context
	const { project } = useContext(ContextProject);

	// state
	const [pagination, setPagination] = useState<Pagination>({
		...defaultPagination,
		perPage: 5,
	});
	const [tags, setTags] = useState<Tag[]>([]);

	// fetch tags
	const { isLoading, refetch: refetchTags } = useFetch({
		isEnabled: Boolean(project),
		url: `${process.env.REACT_APP_API_URL}/tags?project=${project?.id}&page=${paramPage}&limit=${pagination.perPage}`,
		options: {
			headers: {
				Authorization: `Bearer ${accessToken}`,
				User: String(idToken),
			},
		},
		onSuccess: (res) => {
			if (res.data) {
				setTags(res.data);
			}

			if (res.pagination) {
				setPagination(res.pagination);
			}
		},
	});

	return (
		<Container maxWidth={false}>
			<Grid container spacing={2}>
				<Grid item xs={12} lg={4}>
					<Paper
						sx={(theme) => {
							return {
								padding: theme.spacing(2),
								height: '100%',
								minHeight: {
									lg: 400,
								},
							};
						}}>
						<Grid container spacing={2}>
							<Grid item xs={12}>
								<Typography variant="h3">{t('addTag')}</Typography>
							</Grid>
							<Grid item xs={12}>
								<FormAddTag
									onSuccess={() => {
										refetchTags();
									}}
								/>
							</Grid>
						</Grid>
					</Paper>
				</Grid>
				<Grid item xs={12} lg={8}>
					<Paper
						sx={(theme) => {
							return {
								padding: theme.spacing(2),
								height: '100%',
							};
						}}>
						<Grid
							alignItems="stretch"
							container
							direction="column"
							spacing={2}
							sx={{ height: 'calc(100% + 16px)' }}>
							<Grid item>
								<Typography variant="h3">{t('tags')}</Typography>
							</Grid>
							<Grid item flex={1}>
								<TableBasicTags
									borderRadius={2}
									color="grey"
									data={tags}
									hasBorder={true}
									hasStripes={true}
									isLoading={isLoading}
									refetchTags={refetchTags}
									TableFooterProps={{
										numShowing: tags.length,
										pagination,
									}}
								/>
							</Grid>
						</Grid>
					</Paper>
				</Grid>
			</Grid>
		</Container>
	);
};
